<template>
  <v-snackbar v-model="snackbar" v-if="notification" :color="notification.color" :timeout="notification.timeOut" multi-line top>
    {{ notification.text }}
    <template v-slot:action>
      <template v-if="notification.showButton">
        <v-btn
          outlined
          small
          text
          @click="snackbarButtonClicked"
        >
          {{ notification.buttonText }}
        </v-btn>
      </template>
      <template v-else>
        <v-btn icon @click="snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </template>
    </template>
  </v-snackbar>
</template>

<script>
import UiEventBus from "@/UiEventBus";

export default {
  name: 'NotificationSnackbar',
  data() {
    return {
      snackbar: false,
      notification: null,
    }
  },
  methods: {
    snackbarButtonClicked() {
      if (this.notification.callback) {
        this.notification.callback();
      }

      this.snackbar = false;
    },
    setNotification(payload) {
      const notificationObject = {
        color: payload.color,
        text: payload.message,
        timeOut: payload.timeOut !== undefined ? payload.timeOut : 4000,
        showButton: payload.showButton !== undefined ? payload.showButton : false,
        buttonText: payload.buttonText !== undefined ? payload.buttonText : '',
        callback: payload.showButton && payload.callback ? payload.callback : () => {},
      }

      console.log(notificationObject)

      this.notification = notificationObject;
    }
  },
  watch: {
    notification() {
      this.snackbar = true;
    },
  },
  beforeDestroy() {
    UiEventBus.$off('showNotification', this.setNotification)
  },
  mounted() {
    UiEventBus.$on('showNotification', this.setNotification)
  }
}
</script>

<style scoped>

</style>
